import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import envConfig from '../../../config';
import { request } from '../../../common/util/RestClient';
import {
  fetchEventConfigInterval,
  saveEventConfigInterval,
} from '../../routines/integrations/eventConfigRoutines';

function* fetchEventConfigIntervalSaga(action) {
  try {
    const { tenant } = action.payload;
    const url = `${envConfig.APIG_URL}event-config/configs?tenant=${tenant}`;
    const { data } = yield call(request, url);
    yield put(fetchEventConfigInterval.success(data));
  } catch (error) {
    yield put(fetchEventConfigInterval.failure({ error }));
  }
}

function* saveEventConfigIntervalSaga(action) {
  try {
    const { consumer, level, interval } = action.payload;
    const url = `${envConfig.APIG_URL}event-config/configs/interval`;
    const config = {
      method: 'POST',
      payload: {
        consumer,
        level,
        interval,
      },
    };
    const { data } = yield call(request, url, config);
    yield put(saveEventConfigInterval.success(data));
  } catch (error) {
    yield put(saveEventConfigInterval.failure({ error }));
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchEventConfigInterval.TRIGGER, fetchEventConfigIntervalSaga),
    takeLatest(saveEventConfigInterval.TRIGGER, saveEventConfigIntervalSaga),
  ]);
}
